export default __webpack_public_path__ + "static/media/plat-volume.8cd56dfc.png";